module.exports = __webpack_public_path__ + "static/news2-af0b53ded90f1930eae824ad2068a000.png";